// ------------------------------------------------------------------
// Navegación móvil + efecto opacidad al hacer scroll
// ------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const nav    = document.getElementById('mainNav');
  const toggle = document.getElementById('navToggle');
  const panel  = document.getElementById('mobilePanel');
  const hero   = document.querySelector('.ui-hero'); // sección que quieres observar

  /* --- 1. Cambiar fondo del nav al hacer scroll ----------------- */
  if (hero) {
    new IntersectionObserver(
      ([entry]) =>
        nav.classList.toggle('ui-nav--scrolled', !entry.isIntersecting),
      { rootMargin: `-${nav.offsetHeight}px 0px 0px 0px` }
    ).observe(hero); // patrón IO recomendado para rendimiento.:contentReference[oaicite:6]{index=6}
  }

  /* --- 2. Abrir / cerrar panel móvil ---------------------------- */
  const setOpen = (open) => {
    toggle.dataset.open   = open.toString();
    toggle.ariaExpanded   = open.toString();

    if (open) {
      panel.classList.add('ui-nav-mobile-panel--open');
    } else {
      panel.classList.remove('ui-nav-mobile-panel--open');
    }
  };

  // Estado inicial (cerrado)
  setOpen(false);

  // Click hamburguesa
  toggle.addEventListener('click', () =>
    setOpen(toggle.dataset.open === 'false')
  );

  // Cerrar al pulsar ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });

  // Cerrar al navegar dentro del panel
  panel.querySelectorAll('a').forEach((link) =>
    link.addEventListener('click', () => setOpen(false))
  );

  // Cerrar automáticamente al pasar a escritorio
  matchMedia('(min-width: 768px)').addEventListener('change', (e) => {
    if (e.matches) setOpen(false); // evita que quede abierto al redimensionar
  });
});

// ---------- 3D Tilt Effect for Cards ----------
document.querySelectorAll('.ui-card').forEach(card => {
  const prefersMotion = matchMedia('(prefers-reduced-motion: no-preference)').matches;
  if (prefersMotion) {
  document.querySelectorAll('.ui-card').forEach(card => {
    let isTicking = false, rx = 0, ry = 0;

    const update = () => {
      card.style.setProperty('--rx', `${rx}deg`);
      card.style.setProperty('--ry', `${ry}deg`);
      isTicking = false;
    };

    card.addEventListener('pointermove', e => {
      if (e.pointerType === 'touch') return;           // Desactiva en táctil
      const { left, top, width, height } = card.getBoundingClientRect();
      rx = -((e.clientY - top) - height / 2) / 192;
      ry =  ((e.clientX - left) -  width / 2) / 192;
      if (!isTicking) {
        isTicking = true;
        requestAnimationFrame(update);
      }
    });

    card.addEventListener('pointerleave', () => {
      card.style.removeProperty('--rx');
      card.style.removeProperty('--ry');
    });
  });
}
});
document.addEventListener('DOMContentLoaded', () => {
  const isTouch = matchMedia('(hover: none)').matches;
  if (!isTouch) return;                         // nada que hacer en desktop

  document.querySelectorAll('.ui-cart').forEach(card => {
    card.addEventListener('click', e => {
      // evita que un clic en enlaces/botones dispare el toggle
      if (e.target.closest('a, button')) return;
      card.classList.toggle('is-open');
    });
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const terminalContainer = document.getElementById("terminal-container");
  const terminalOutputElement = document.getElementById("terminal-output-text");
  if (terminalContainer && terminalOutputElement) {
    const textToType = "neofetch";
    const typingSpeed = 150;
    let animationStarted = false;
    const typeCommand = () => {
      let charIndex = 0;
      const type = () => {
        if (charIndex < textToType.length) {
          terminalOutputElement.textContent += textToType.charAt(charIndex);
          charIndex++;
          setTimeout(type, typingSpeed);
        }
      };
      type();
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !animationStarted) {
            animationStarted = true;
            setTimeout(typeCommand, 500);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(terminalContainer);
  }
});
/* ─── DONUT ASCII VERY-BASIC ─────────────────────────────────────────── */
(() => {
  const pre = document.getElementById('donut-out');
  if (!pre) return;

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    pre.textContent = '(animación desactivada)';
    return;
  }

  const LUM = '.,-~:;=!*#$@';
  const charW = 6;  // aprox. monospace 10 px
  const charH = 10;

  let cols, rows, zBuf, chr, A = 0, B = 0;

  function resize() {
    const w = pre.clientWidth,
          h = pre.parentElement.clientHeight - 32; // header + padding
    cols = Math.max(14, Math.floor(w / charW) - 1);
    rows = Math.max(10, Math.floor(h / charH));
    pre.style.height = rows * charH + 'px';

    zBuf = new Float32Array(cols * rows);
    chr  = Array(cols * rows).fill(' ');
  }

  resize();
  new ResizeObserver(resize).observe(pre);

  function frame() {
    zBuf.fill(0);
    chr.fill(' ');

    for (let j = 0; j < 6.28; j += 0.3)
      for (let i = 0; i < 6.28; i += 0.05) {
        const sinA=Math.sin(A), cosA=Math.cos(A),
              sinB=Math.sin(B), cosB=Math.cos(B),
              sinI=Math.sin(i), cosI=Math.cos(i),
              sinJ=Math.sin(j), cosJ=Math.cos(j);

        const h = cosI + 2;
        const D = 1 / (sinI * h * sinA + sinJ * cosA + 5);
        const t = sinI * h * cosA - sinJ * sinA;

        const x = (cols/2 + (cols/2.1)*D*(cosI*h*cosB - t*sinB))|0;
        const y = (rows/2 + (rows/2.1)*D*(cosI*h*sinB + t*cosB))|0;
        const o = x + cols * y;

        const N = (8*((sinJ*sinA - sinI*cosJ*cosA)*cosB
                    - sinI*cosJ*sinA - sinJ*cosA
                    - cosI*cosJ*sinB))|0;

        if (y>=0 && y<rows && x>=0 && x<cols && D>zBuf[o]) {
          zBuf[o] = D;
          chr[o]  = LUM[N>0?N:0];
        }
      }

    let txt = '';
    for (let r = 0; r < rows; r++)
      txt += chr.slice(r*cols,(r+1)*cols).join('') + '\n';

    pre.textContent = txt;
    A += 0.07; B += 0.03;
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
